// ============================================
// ROLC OneROLC - DOM Helpers
// Version: 3.6.0
// ============================================

// ============================================
// Selector Shortcuts
// ============================================
export function $(selector, context = document) {
    return context.querySelector(selector);
}

export function $$(selector, context = document) {
    return context.querySelectorAll(selector);
}

// ============================================
// Element Creation
// ============================================
export function createElement(tag, className, html, attrs = {}) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (html) el.innerHTML = html;
    for (const [key, value] of Object.entries(attrs)) {
        el.setAttribute(key, value);
    }
    return el;
}

// ============================================
// Class Helpers
// ============================================
export function addClass(el, className) {
    if (el) el.classList.add(className);
}

export function removeClass(el, className) {
    if (el) el.classList.remove(className);
}

export function toggleClass(el, className) {
    if (el) el.classList.toggle(className);
}

export function hasClass(el, className) {
    return el ? el.classList.contains(className) : false;
}

// ============================================
// Content Setter
// ============================================
export function setContent(html) {
    const content = document.getElementById("content");
    if (content) content.innerHTML = html;
}


